import React from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Retrieves search object from url search params using {@link react-router-dom#useLocation}
 * Results will only be computed at redirection (page refresh included),
 * meaning updating search params without redirecting won't update them
 * @returns {module:url.URLSearchParams}
 */
export const  useQuery = () => {
  const { search } = useLocation();

  return React.useMemo(() => new URLSearchParams(search), [search]);
}